import { useEffect, useState, useRef } from 'react';

import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import Loading from "../../../components/Loading";

import api from "../../../services/api";

export const AddPermissaoVerOcorrencia = ({ visible, onHide, onSuccess }) => {
    const [usuarios, setUsuarios] = useState(null);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
    const [permissao, setPermissao] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [usuariosPermitidos, setUsuariosPermitidos] = useState([]);
    const [isLoadingPermitidos, setIsLoadingPermitidos] = useState(false);
    const toast = useRef();

    useEffect(() => {
        if (!visible) return;

        api.get('users/buscar-usuarios')
            .then(response => {
                const options = response.data.map(user => ({
                    label: `${user.name} (${user.email})`,
                    value: user.id,
                    permissao: user.ver_ocorrencias
                }));

                setUsuarios(options)
            });

    }, [visible]);

    useEffect(() => {
        if (!visible) return;

        const loadPermitidos = async () => {
            setIsLoadingPermitidos(true);

            try {
                const response = await api.get('users/permissao-ocorrencia');

                setUsuariosPermitidos(
                    response.data.map(user => ({
                        label: user.name,
                        email: user.email,
                        value: user.id,
                        permissao: user.ver_ocorrencias
                    }))
                );
            } catch (e) {
                console.error(e);
            } finally {
                setIsLoadingPermitidos(false);
            }
        };

        loadPermitidos();
    }, [visible]);

    if (isLoading) {
        return <Loading />
    }

    const handleSave = async () => {
        if (!usuarioSelecionado) return;

        try {
            setIsLoading(true);

            await api.put(
                `/users/${usuarioSelecionado}/permissoes-ocorrencias`,
                {
                    ver_ocorrencias: permissao
                }
            );

            onHide();
            onSuccess();
            setUsuarioSelecionado(null);
            setPermissao(null);

        } catch (error) {
            console.error(error);
            const message = error.response?.data?.message || 'Erro ao salvar permissão. Tente novamente.';

            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: message,
                life: 5000
            });

        } finally {
            setIsLoading(false);
        }
    };


    return (
        <Dialog
            header="Adicionar permissão para ver ocorrências"
            visible={visible}
            onHide={onHide}
            style={{ minWidth: '40%' }}
        >
            {isLoadingPermitidos ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '150px' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                <div className="flex flex-column mb-4">
                    <p>Usuários com acesso restrito:</p>
                    {usuariosPermitidos.map(user => (
                        <div
                            key={user.value}
                            className="p-3 border-bottom-1 surface-border"
                        >
                            <span><strong>{user.label}</strong> ({user.email})</span>
                        </div>
                    ))}
                </div>
            )} <br />
            <div className="p-fluid editor">
                <div className="p-field">
                    <label htmlFor="usuario">Usuário </label>
                    <Dropdown
                        value={usuarioSelecionado}
                        options={usuarios}
                        onChange={(e) => {
                            setUsuarioSelecionado(e.value);

                            const user = usuarios.find(u => u.value === e.value);
                            setPermissao(user?.permissao ?? null);
                        }}
                        placeholder='Selecione um usuário'
                        optionLabel="label"
                        className="p-m-1"
                        showClear
                    />
                </div>
                <div className="p-field">
                    <label>Permissão</label>
                    <div className="p-formgrid p-grid">
                        <div className="p-field-radiobutton p-col-12 p-md-4">
                            <RadioButton
                                inputId="tudo"
                                name="permissao"
                                value={null}
                                onChange={(e) => setPermissao(e.value)}
                                checked={permissao === null}
                            />
                            <label htmlFor="tudo">Produção</label>
                        </div>

                        <div className="p-field-radiobutton p-col-12 p-md-4">
                            <RadioButton
                                inputId="atribuidos"
                                name="permissao"
                                value="ver_atribuidos"
                                onChange={(e) => setPermissao(e.value)}
                                checked={permissao === 'ver_atribuidos'}
                            />
                            <label htmlFor="atribuidos">Supervisão</label>
                        </div>
                    </div>
                </div>
                <div className="p-d-flex p-flex-row">
                    <Button className="p-button-secondary p-mr-6" label="Cancelar" onClick={onHide} />
                    <Button className="p-button-success p-ml-6" label="Salvar" disabled={isLoading || !usuarioSelecionado} onClick={handleSave} loading={isLoading} />
                </div>
            </div>

        </Dialog>
    )
}